import { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { NavigateLinks, BackToModuleButton } from '@/components';

import { childrenCompaniesPageBreadcrumbs } from '../../config/breadcrumbs';
import { EditCompanyForm } from '../../components';

const EditCompany = () => {

  const { id } = useParams<{ id: string }>();
  if (!id) throw new Error('El id de la compañía es requerido');
  
  const navigate = useNavigate();
  const breadcrumbs = useMemo(
    () => childrenCompaniesPageBreadcrumbs(navigate),
    [navigate]
  );
  
  return (
    <section className="flex h-full w-full flex-col gap-6">
      <NavigateLinks actualPage={id} breadcrumbs={breadcrumbs} />
      <div className="flex justify-end">
        <BackToModuleButton breadcrumbs={breadcrumbs} />
      </div>
      <div className="flex flex-1 items-start justify-center pt-16">
        <EditCompanyForm />
      </div>
    </section>
  );
};

export default EditCompany;
